import React from 'react'
import PropTypes from 'prop-types'
import { Columns, Column, Section } from '@paper-monster/web/src/components/layout'
import { Text } from '@paper-monster/web/src/components/common'
import RecaptchaTerms from '@paper-monster/web/src/components/common/RecaptchaTerms'
import FooterExternalLinks from '@paper-monster/web/src/components/layout/Footer/FooterExternalLinks'
import { useSiteConfig } from '@paper-monster/web/src/components/Providers/SiteConfigProvider'

import { COMPANY_NAV, ENV } from '@/config'

import FooterNavList from './FooterNavList'
import FooterMailingList from './FooterMailingList'
import styles from './Footer.module.scss'

// One nav list, Company; the site holds no BBB accreditation, so no seal.
export default function Footer({ hideNav }) {
  const { links } = useSiteConfig()
  const colProps = { className: styles.col, size: 20 }
  return (
    <Section
      className={styles.section}
      gap={0}
      paddingHorizontal={24}
      paddingVertical={0}
      wrapperClassName={styles.sectionWrapper}
    >
      <Columns className={styles.cols} element="footer" gap={0} wrap>
        <Column {...colProps}>
          <FooterExternalLinks homeHref={links.home} />
        </Column>
        {hideNav ||
        <Column {...colProps}>
          <FooterNavList navItems={COMPANY_NAV} titleMessageId="footer.navLists.company" />
        </Column>}
        <Column {...colProps}>
          <FooterMailingList />
        </Column>
      </Columns>
      <footer className={styles.copyrightWrapper}><Text.P center messageId="copyright" onTint size="tiny" suppressHydrationWarning /></footer>
      <RecaptchaTerms linkProps={{ className: styles.navLink }} textProps={{ onTint: true }} />
      {ENV !== 'production' && ENV !== 'development' && <Text.P onTint size="tiny">Tag: {process.env.NEXT_PUBLIC_BUILD_TAG}</Text.P>}
    </Section>
  )
}

Footer.propTypes = {
  hideNav: PropTypes.bool,
}
